import t from "react";
import { useTheme as n } from "@chakra-ui/react";
import { MdFacebook as s } from "react-icons/md";
import { FaInstagramSquare as l } from "react-icons/fa";
import { Icon as u } from "../icon/icon.js";
import "@loadable/component";
import { Button as f } from "./button.js";
import "./icon-button.js";
import "./masthead-button.js";
import "@chakra-ui/system";
import "framer-motion";
import "react-icons/fi";
import "react-icons/hi";
import "react-icons/ri";
import "react-icons/io5";
import "./close-button.js";
const d = {
  facebook: s,
  instagram: l
}, M = ({
  icon: m,
  iconHeight: r,
  ...e
}) => {
  const {
    action: { primaryDefault: a, primaryHover: i, primaryFocus: p, primaryPressed: c },
    button: { largeIcon: o }
  } = n();
  return /* @__PURE__ */ t.createElement(
    f,
    {
      ...e,
      variant: "transparent",
      color: a,
      _hover: { color: i },
      _focus: { color: p },
      _pressed: { color: c }
    },
    /* @__PURE__ */ t.createElement(
      u,
      {
        as: d[m],
        w: r ?? o,
        h: r ?? o,
        role: "img",
        "aria-hidden": "true"
      }
    )
  );
};
export {
  M as SocialIconButton,
  d as socialIcons
};
